module.exports = __webpack_public_path__ + "img/guide 2.b63a3f0f.svg";